import { clients as API } from '../../api'

import { store } from 'w3box-vue-api'
const { state, getters, actions, mutations } = store

export default {
  namespaced: false,
  state: state(),
  getters: getters(),
  actions: actions(API),
  mutations: mutations(),
}